import { H7, Stack, styledPolymorphic } from '@qred/components-library';
import React from 'react';

const DotsContainer = styledPolymorphic()(
  (styled) => styled`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`
);

const TextBlock = styledPolymorphic()(
  (styled) => styled`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  animation: stepTextIn 1.5s ease;

  @keyframes stepTextIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`
);

const Dot = styledPolymorphic<'div', { $isActive: boolean }>()(
  (styled) => styled`
  height: 8px;
  width: ${({ $isActive }) => ($isActive ? '32px' : '8px')};
  border-radius: ${({ $isActive }) => ($isActive ? '4px' : '50%')};
  background-color: ${({ $isActive, theme }) =>
    $isActive
      ? theme.fn.themeColor('Main/Primary/900')
      : theme.fn.themeColor('Main/Grey/Alpha/OnLight/10%')};
  transition: width 0.3s ease, border-radius 0.3s ease, background-color 0.3s ease;
`
);

interface Props {
  title: string;
  currentStep: number;
  totalSteps: number;
}

export const DotsStepper: React.FC<Props> = ({
  title,
  currentStep,
  totalSteps,
}) => (
  <Stack align="center">
    <TextBlock key={currentStep}>
      <H7 color="Text/Default">{title}</H7>
    </TextBlock>
    <DotsContainer>
      {Array.from({ length: totalSteps }, (_, index) => (
        <Dot key={index} $isActive={index === currentStep} />
      ))}
    </DotsContainer>
  </Stack>
);
